import React, { useState, useEffect } from 'react';
import {Pagination as ReactPagination} from 'react-bootstrap'
import _ from 'lodash'

export default function Pagination({className = '', page = 1, lastPage = 1, goToPage = (p)=>{}}) {

  page = parseInt(page)
  lastPage = parseInt(lastPage)
  
  // if (lastPage <= 1) {
  //   return null
  // }

 const minPage = Math.max(page - 2, 1)
 const maxPage = Math.max(Math.min(page+2, lastPage), Math.min(5, lastPage))

  return (
    <ReactPagination className={className}>
      <ReactPagination.First disabled={1 == page} onClick={()=>goToPage(1)} />
      <ReactPagination.Prev disabled={1 == page} onClick={()=>goToPage(parseInt(page)-1)} />
      { _.range(minPage, maxPage + 1).map((i)=>
        <ReactPagination.Item key={i} active={i==page} onClick={()=> goToPage(i)}>{i}</ReactPagination.Item>)
      }
      <ReactPagination.Next disabled={lastPage == page} onClick={()=>goToPage(parseInt(page)+1)} />
      <ReactPagination.Last disabled={lastPage == page} onClick={()=>goToPage(lastPage)}  />
    </ReactPagination>
  );
}
